import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    minHeight: 360,
    [theme.breakpoints.down('tablet')]: {
      minWidth: 320,
      paddingTop: 30,
    },
    [theme.breakpoints.up('tablet')]: {
      minWidth: 400,
    },

    padding: SPACES.xxl,
  },
}))
